package com.anjuros.website.redesign.sections.contactforms

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.components.RdClosingCard
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText

@Composable
fun ContactFormsClosingSection() {
    RdClosingCard(
        RdText.FORMS_CLOSE_EYEBROW, RdText.FORMS_CLOSE_TITLE, RdText.FORMS_CLOSE_LEDE,
        secondaryText = RdText.FORMS_CLOSE_PRICING, secondaryPath = RdRoute.PRICING,
    )
}
